import { Lens, Fold, Getter } from "@discovery/prelude/lib/control/lens";
import * as Res from "@discovery/sonic-api-ng/lib/japi/response";
import { _Response2ResponseData } from "./common";
/**
 * Getters
 */
export const _RouteGetter = Getter.of();
export const _RouteResponseGetter = Getter.of();
export const _RoutesGetter = Getter.of();
export const _RoutesResponseGetter = Getter.of();
/**
 * Lenses
 */
export const _RoutesResponse2Routes = Fold.mapF((res) => Res.map((x) => x.data, res));
export const _RouteResponse2Route = _Response2ResponseData();
export const _Route2Data = Fold.compose(_RouteGetter, Res._Response());
export const _Route2Attributes = Fold.compose(_Route2Data, Lens.prop("attributes"));
export const _RouteAttributes2Canonical = Fold.compose(_Route2Attributes, Lens.prop("canonical"));
export const _RouteAttributes2Url = Fold.compose(_Route2Attributes, Lens.prop("url"));
export const _Route2Target = Fold.compose(_RouteGetter, Res._Rel("target"));

